import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { Period } from "@state/common/PeriodConverter";
import { useContext } from "react";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";

export function ExpandedPeriodMenuItem(props: {
	period: Period;
	name: string;
	store: {
		toggleUpdateProcessing: () => void;
		periodSubMenu: {
			setPeriodKey: (p: Period, shouldOpenOfferMenu: boolean) => void;
		};
	};
}) {
	const params = useParams<{ period: string }>();
	const location = useLocation();
	const shouldOpenOfferMenu = !location.pathname.includes("/my-favorites");
	const { t } = useTranslation();
	const favoriteStore = useContext(FavoritesStoreContext);

	return (
		<button
			className={classnames("nav--tertiary__link", {
				"is-active": params.period === props.period,
			})}
			onClick={() => {
				props.store.toggleUpdateProcessing();
				props.store.periodSubMenu.setPeriodKey(
					props.period,
					shouldOpenOfferMenu
				);
				favoriteStore.setPeriod(props.period);
			}}
		>
			<span className="nav--tertiary__title nav--tertiary__title--center">
				<i
					className={`nav--tertiary__icon u-icon u-icon--base u-icon--${props.period}`}
				/>
				<span>{t(props.name)}</span>
			</span>
		</button>
	);
}
